import React from 'react';

interface GrowlyyLogoProps {
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

const GrowlyyLogo: React.FC<GrowlyyLogoProps> = ({ className = '', size = 'medium' }) => {
  // Définir les tailles en fonction du paramètre size
  const sizes = {
    small: { width: 100, height: 30 },
    medium: { width: 150, height: 45 },
    large: { width: 200, height: 60 }
  };

  const { width, height } = sizes[size];

  return (
    <div className={`flex items-center ${className}`} style={{ width, height }}>
      <svg width={height} height={height} viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Flèche et éléments du logo */}
        <g>
          {/* Flèche principale */}
          <path d="M150 100 L220 170 L150 240" stroke="#3D2A54" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          
          {/* Éléments roses/rouges */}
          <circle cx="70" cy="170" r="20" fill="#E31B54" />
          <circle cx="110" cy="110" r="20" fill="#E31B54" />
          <circle cx="110" cy="230" r="20" fill="#E31B54" />
          <rect x="50" y="160" width="40" height="20" rx="10" fill="#E31B54" />
        </g>
      </svg>
      
      {/* Texte "Growlyy" */}
      <div className="ml-2 text-growlyy-primary font-bold" style={{ fontSize: size === 'small' ? '1.5rem' : size === 'medium' ? '2rem' : '2.5rem' }}>
        Growlyy<span className="text-growlyy-secondary">.</span>
      </div>
    </div>
  );
};

export default GrowlyyLogo; 